import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import './App.css';

import {
  BrowserRouter,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";

import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';

function App() {
  const location = useLocation();

  return (
    <>
    <Header />
    <div id="siteContent">
      <TransitionGroup component={null}>
        <CSSTransition key={location.key} classNames="fade" timeout={300}>
          <Routes location={location}>
            {/* <Route path="/profile" element={<Profile />} />
            <Route path="/timeline" element={<Timeline />} />
            <Route path="/countdown" element={<Countdown />} />
            <Route path="/stories" element={<Stories />} /> */}
            <Route path="*" element={<Home />} />
          </Routes>
        </CSSTransition>
      </TransitionGroup>
    </div>
    <Footer />
    </>
  );
}

// Placed the context provider here so that <App/> can call useLocation()
const Root = () => <BrowserRouter><App /></BrowserRouter>;

ReactDOM.render(<Root />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();